<template>
  <div>
    <collapsible-widget
    icon="map"
    colorBadge="info"
    :collapsed="collapsed"
    :title="title_component"
  >
    <div class="input-group">
      <div class="input-group-prepend">
        <label class="input-group-text" for="inputGroupSelect01">{{
          tx(this.attributes.label)
        }}</label>
        <helpWidget
          v-if="this.attributes.help_img || this.attributes.help"
          class="md-layout-item"
          :help="help_key"
          :help_img="`${this.IREALCONFIG.static_ressources}/${this.attributes.help_img}.png`"
          :help_style="this.attributes.help_style"
        ></helpWidget>
      </div>
      <div class="divtest" id="divtest" style="width: 100%">
        <!-- TO DO: corriger le fait qu'en cas de plusisuers MAP il y aura plusieurs ID identiques -->
        <map id="carte" name="carte">
          <div v-for="(k, v) in options" :key="k">
            <area
              shape="rect"
              :coords="`${ratios(k.toString())}`"
              @click="toogleCollapsed(v)"
              data-reveal-id="testmodal"
              :title="`Click to highlight the corresponding graphic : ${v}`"
            />
          </div>
        </map>
        <img id="test" usemap="#carte" :src="src" alt="..." @load="resize" />
      </div>
    </div>
  </collapsible-widget>
    <component
      :expandMapSelect="collapsed"
      :collapsed="collapsed"
      v-for="element in config.elements"
      :key="element.id"
      :is="getComponentName(element)"
      :config="element"
      :id="element.model"      
    ></component>
    <!--
    <div
      v-for="f in definitions"
      class="graphic"
      :class="f.attributes.model"
      :key="f.attributes.model"
    >
      <collapsible-widget
        :expandMapSelect="collapsed"
        :collapsed="collapsed"
        :uuid="uuid"
        :title="title_component"
        :badge="badge"
        v-show="id_selected ? id_selected == is_output_selected : true"
        :icon="f.icon"
        :colorBadge="f.type_collapsible == 'output' ? 'info' : 'primary'"
        :message="f.message ? true : false"
        :id="uuid"
      >
        {{ collapsed }}
      </collapsible-widget>
    </div>
  --></div>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import CollapsibleWidget from "ireal-vue/widgets/CollapsibleWidget.vue";
import Bus from "../services/bus.js";

export default {
  name: "map-select-component",
  mixins: [componentMixin, inputComponentMixin],
  components: { CollapsibleWidget },
  data() {
    return {
      badge: "badge_filter",
      selected: null,
      EventProgress: "0",
      imgHeight: 0,
      imgWidth: 0,
      coordA: 0,
      coordB: 0,
      coordC: 0,
      coordD: 0,
      definitions: null,
      listRatios: null,
    };
  },
  async mounted() {
    this.selected = this.attributes.default;
    this.resize();
  },
  async created() {
    this.definitions = this.config.elements;
    Bus.$on("event progress", (msg) => {
      this.EventProgress = msg;
    });
    window.addEventListener("resize", this.resize);
  },
  watch: {
    selected: function (value) {
      this.isSelected = [];
      for (var o in this.options) {
        this.isSelected.push(this.tx(`${this.model}_${this.options[o]}`));
      }
      var index = this.isSelected.indexOf(value);
      index !== -1 ? this.isSelected.splice(index, 1) : "";
      this.$store.commit("setSelected", { param: this.model, value });
    },
  },
  methods: {
    scrollToElement(id_component) {
      document.getElementById(id_component).scrollIntoView({
        behavior: "smooth",
      });
      this.selected = id_component

    },
    toogleCollapsed(graphic) {
      this.scrollToElement(graphic);
      this.$store.commit("setSelected", {
        param: this.model,
        value: graphic,
        mode: "highlight",
      });
      (this.$store.getters.listSelected["highlight"] = graphic)
      return (this.collapsed = !this.collapsed);
    },
    resize() {
      // tool to find coordinates of rect on origin picture: https://www.image-map.net/
      // coord = point supérieur gauche ( x et y ) et point inférieur droit (x et y)
      var test = document.getElementById("test");
      var divtest = document.getElementById("divtest");
      this.imgHeight =
        divtest.clientWidth / (test.naturalWidth / test.naturalHeight);

      // si l'image sur l'écran est supérieure aux tailles originales de l'image alors on applique les tailles originales:
      this.imgHeight =
        this.imgHeight > test.naturalHeight
          ? test.naturalHeight
          : this.imgHeight;
      this.imgWidth =
        this.imgWidth > test.naturalWidth
          ? test.naturalWidth
          : divtest.clientWidth;

      this.coordA = Math.round(parseInt(this.imgWidth) * this.ratios[0]);
      this.coordB = Math.round(parseInt(this.imgHeight) * this.ratios[1]);
      this.coordC = Math.round(parseInt(this.imgWidth) * this.ratios[2]);
      this.coordD = Math.round(parseInt(this.imgHeight) * this.ratios[3]);
    },
    ratios(coordinate_brut) {
      var coordinates = coordinate_brut.split("|");
      var top_left_x = Math.round(parseInt(this.imgWidth) * coordinates[0]);
      var top_left_y = Math.round(parseInt(this.imgWidth) * coordinates[1]);
      var bottom_right_x = Math.round(parseInt(this.imgWidth) * coordinates[2]);
      var bottom_right_y = Math.round(parseInt(this.imgWidth) * coordinates[3]);
      return `${top_left_x},${top_left_y},${bottom_right_x},${bottom_right_y}`;
    },
  },
  computed: {
    src() {
      return `${this.IREALCONFIG.static_ressources}/${this.attributes.src}`;
    },
    options() {
      if (this.attributes.options === undefined) return [];
      else return JSON.parse(this.attributes.options);
    },

  },
};
</script>
<style scoped>
/* ce style est calé sur le style de 'container-fluid' dans lequel est intégré un collapsibleWidget*/
.input-group {
  padding-left: 15px;
  padding-right: 15px;
}
</style>
